import {getData, USER_DATA} from "../storage";
import {isEmpty, logErrorToMyService} from "../utility";
import moment from "moment";
import * as _ from "lodash";

const getBroadcasterObject = (callback) => {
    getData(USER_DATA).then((data) => {
        if (!isEmpty(data)) {
            console.log("getBroadcasterObject >> data", data)
            if (data && data.hasOwnProperty("broadcaster") && Array.isArray(data.broadcaster) && data.broadcaster.length > 0) {
                callback(data.broadcaster[0]);
            }else{
                callback(null);
            }
        }else{
            callback(null);
        }
    });
}

const getUserObject = (callback) => {
    getData(USER_DATA).then((data) => {
        if (!isEmpty(data)) {
            console.log("getUserObject >> data", data)
            callback(data);
        }else{
            callback(null);
        }
    });
}

const getChatIds = (from,to, item, callback) => {

    let chatIdsArray = [];
    getData(USER_DATA).then((data) => {
        if (!isEmpty(data)) {
            if (from === "user") {
                if (data && data.hasOwnProperty("user_id")) {
                    chatIdsArray.push(data.user_id);
                }
            } else {
                if (data && data.hasOwnProperty("broadcaster") && Array.isArray(data.broadcaster) && data.broadcaster.length > 0) {
                    chatIdsArray.push(data.broadcaster[0].broadcaster_id);
                }
            }

            if (to === "user") {
                chatIdsArray.push(item.user_id);
            } else {
                chatIdsArray.push(item.broadcaster_id);
            }
        }

        callback(chatIdsArray);
    });

}

const isSameDay = (currentMessage = {}, diffMessage = {}) => {
    if (!diffMessage.createdAt) {
        return false;
    }

    const currentCreatedAt = moment(currentMessage.createdAt);
    const diffCreatedAt = moment(diffMessage.createdAt);

    if (!currentCreatedAt.isValid() || !diffCreatedAt.isValid()) {
        return false;
    }

    return currentCreatedAt.isSame(diffCreatedAt, 'day');
}

const isSameUser = (currentMessage = {}, diffMessage = {}) => {
    return !!(diffMessage.user && currentMessage.user && diffMessage.user.id === currentMessage.user.id);
}

const getUserType = (props) => {
    return props.item.metaData.is_user === "True" ? "user" : "broadcaster"
}

const retrieveMemberDetails = (props, channel) => {
    console.log("retrieveMemberDetails",channel)
    let members = channel.members;
    let id = props.user_type === "broadcaster" ? props.broadcaster.broadcaster_id : props.user.user_id;
    return _.filter(members, function (member) {
        return member.userId !== id;
    });
}

const randomValue = () => {
    let attachment = {
        "one": [{
            "amount": 0,
            "duration": 61,
            "duration_formatted": "01:01",
            "id": "26d084c0-33b5-11eb-8176-6f23e29d6731",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS92aWRlb3MvY2FiMzA1M2EtZDkwYS00N2QxLWFlNjctMmQwNjc5NWVjNjQxL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Visit test",
            "total_videos": 0,
            "type": "video",
            "url": ""
        }],
        "two":  [{
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3cb820-3466-11eb-828d-3b90a303eef6",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvNjM3N2I2OGEtOTNlMi00NzRmLTkyODQtZGVhOWE3YWEyMmZlL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "New Picture",
            "total_videos": 0,
            "type": "gallery",
            "url": ""
        }, {
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3fe3f0-3466-11eb-8bfc-ef64a94c37e5",
            "pricing_type": "free",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvMTNiODk1YjYtY2Y0Yy00YTBhLWEzNmEtYzg4NzRmZDUyZDVlL3RodW1ibmFpbC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Free Gallery",
            "total_videos": 4,
            "type": "gallery",
            "url": ""
        }],
        "three": [{
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3cb820-3466-11eb-828d-3b90a303eef6",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvNjM3N2I2OGEtOTNlMi00NzRmLTkyODQtZGVhOWE3YWEyMmZlL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "New Picture",
            "total_videos": 0,
            "type": "gallery",
            "url": ""
        }, {
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3fe3f0-3466-11eb-8bfc-ef64a94c37e5",
            "pricing_type": "free",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvMTNiODk1YjYtY2Y0Yy00YTBhLWEzNmEtYzg4NzRmZDUyZDVlL3RodW1ibmFpbC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Free Gallery",
            "total_videos": 4,
            "type": "gallery",
            "url": ""
        },{
            "amount": 0,
            "duration": 61,
            "duration_formatted": "01:01",
            "id": "26d084c0-33b5-11eb-8176-6f23e29d6731",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS92aWRlb3MvY2FiMzA1M2EtZDkwYS00N2QxLWFlNjctMmQwNjc5NWVjNjQxL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Visit test",
            "total_videos": 0,
            "type": "video",
            "url": ""
        }],
        "four": [{
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3cb820-3466-11eb-828d-3b90a303eef6",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvNjM3N2I2OGEtOTNlMi00NzRmLTkyODQtZGVhOWE3YWEyMmZlL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "New Picture",
            "total_videos": 0,
            "type": "gallery",
            "url": ""
        }, {
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3fe3f0-3466-11eb-8bfc-ef64a94c37e5",
            "pricing_type": "free",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvMTNiODk1YjYtY2Y0Yy00YTBhLWEzNmEtYzg4NzRmZDUyZDVlL3RodW1ibmFpbC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Free Gallery",
            "total_videos": 4,
            "type": "gallery",
            "url": ""
        },{
            "amount": 0,
            "duration": 61,
            "duration_formatted": "01:01",
            "id": "26d084c0-33b5-11eb-8176-6f23e29d6731",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS92aWRlb3MvY2FiMzA1M2EtZDkwYS00N2QxLWFlNjctMmQwNjc5NWVjNjQxL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Visit test",
            "total_videos": 0,
            "type": "video",
            "url": ""
        },{
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3cb820-3466-11eb-828d-3b90a303eef6",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvNjM3N2I2OGEtOTNlMi00NzRmLTkyODQtZGVhOWE3YWEyMmZlL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "New Picture",
            "total_videos": 0,
            "type": "video",
            "url": ""
        }],
        "five": [{
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3cb820-3466-11eb-828d-3b90a303eef6",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvNjM3N2I2OGEtOTNlMi00NzRmLTkyODQtZGVhOWE3YWEyMmZlL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "New Picture",
            "total_videos": 0,
            "type": "gallery",
            "url": ""
        }, {
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3fe3f0-3466-11eb-8bfc-ef64a94c37e5",
            "pricing_type": "free",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvMTNiODk1YjYtY2Y0Yy00YTBhLWEzNmEtYzg4NzRmZDUyZDVlL3RodW1ibmFpbC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Free Gallery",
            "total_videos": 4,
            "type": "gallery",
            "url": ""
        },{
            "amount": 0,
            "duration": 61,
            "duration_formatted": "01:01",
            "id": "26d084c0-33b5-11eb-8176-6f23e29d6731",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS92aWRlb3MvY2FiMzA1M2EtZDkwYS00N2QxLWFlNjctMmQwNjc5NWVjNjQxL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Visit test",
            "total_videos": 0,
            "type": "video",
            "url": ""
        },{
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3cb820-3466-11eb-828d-3b90a303eef6",
            "pricing_type": "paid",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvNjM3N2I2OGEtOTNlMi00NzRmLTkyODQtZGVhOWE3YWEyMmZlL3RodW1ibmFpbC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "New Picture",
            "total_videos": 0,
            "type": "video",
            "url": ""
        }, {
            "amount": 0,
            "duration": 0,
            "duration_formatted": "0.00",
            "id": "9e3fe3f0-3466-11eb-8bfc-ef64a94c37e5",
            "pricing_type": "free",
            "thumbnail_url": "https://dgsnexqo3t7f4.cloudfront.net/eyJidWNrZXQiOiJjbGlwc3RvcmUtdnVlcGF5LWNvbSIsImtleSI6ImRldmVsb3BtZW50L3VzZXIvYmY3Yjc0MDQtNjMwNC00MGU5LTkwMTUtY2I5N2M3ODc1N2ZmL2Jyb2FkY2FzdGVyL2NsaXBzdG9yZS9nYWxsZXJpZXMvMTNiODk1YjYtY2Y0Yy00YTBhLWEzNmEtYzg4NzRmZDUyZDVlL3RodW1ibmFpbC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUwMCwiZml0IjoiY292ZXIifX19",
            "title": "Free Gallery",
            "total_videos": 4,
            "type": "gallery",
            "url": ""
        }]
    }
    return attachment[Object.keys(attachment)[Math.floor(Math.random() * Object.keys(attachment).length)]]
}


const generateMessageForGiftChat = (sendBirdMessage) => {
    console.log("generateMessageForGiftChat",sendBirdMessage.data)
    let data = null;
    try {
        if (sendBirdMessage.data) {
            data = sendBirdMessage.data;
            // preserve newlines, etc - use valid JSON
            data = data.replace(/\\n/g, "\\n")
                .replace(/\\'/g, "\\'")
                .replace(/\\"/g, '\\"')
                .replace(/\\&/g, "\\&")
                .replace(/\\r/g, "\\r")
                .replace(/\\t/g, "\\t")
                .replace(/\\b/g, "\\b")
                .replace(/\\f/g, "\\f");
// remove non-printable and other non-valid JSON chars
            data = data.replace(/[\u0000-\u0019]+/g, "");
            data = JSON.parse(data);
        }
    } catch (error) {
        logErrorToMyService("generateMessageForGiftChat", error)
        data = null;
    } finally {
        return {
            id: sendBirdMessage.messageId,
            text: sendBirdMessage.message,
            createdAt: sendBirdMessage.createdAt,
            user: {
                id: sendBirdMessage._sender.userId,
                name: sendBirdMessage._sender.nickname,
                avatar: sendBirdMessage._sender.profileUrl,
            },
            data
        }
    }
}

const getLightBoxObject = (url,type,altTag) => {
    return{
        url,
        type,
        altTag
    }
}
const getLightBoxData = (apiData) => {
    /**
     * Lightbox object { url: 'https://placekitten.com/450/300', type: 'photo' || 'video', altTag: 'some image' }
     */
    let data = [];
    apiData.map((_data, index) => {
        let type = "video";

        if (_data.hasOwnProperty("type")) {
            if (_data.type === "picture") {
                type = "photo"
                data.push(getLightBoxObject(_data["url"],type,_data["title"]))
            } else {
                data.push(getLightBoxObject(_data["url"],type,_data["title"]))
            }
        } else if (_data.hasOwnProperty("videos") || _data.hasOwnProperty("pictures")) {
            if (_data.hasOwnProperty("videos") && _data.videos.length > 0) {
                type = "video"
                _data.videos.map((video)=>{
                    data.push(getLightBoxObject(video["url"],type,video["title"]))
                })
            } else if (_data.hasOwnProperty("pictures") && _data.pictures.length > 0) {
                type = "photo"
                _data.pictures.map((picture)=>{
                    data.push(getLightBoxObject(picture["thumbnail_url"],type,picture["title"]))
                })
            }
        }
    })

    return data;
}
export default {
    getBroadcasterObject,
    getUserObject,

    getChatIds,
    isSameDay,
    isSameUser,
    getUserType,
    retrieveMemberDetails,
    generateMessageForGiftChat,
    getLightBoxData
}